import React from 'react';

import Banner from './banner';
import withPageComponents from '../../page/components/with-page-components';

const TopBanner = ({ vwaTopBanner }) => {
    if (!vwaTopBanner) return null;
    return <Banner className="vwa-top-banner" banner={vwaTopBanner} loading="eager" prefetch={true} />;
};

export default withPageComponents(TopBanner, { components: ['vwaTopBanner'] });
